import { Box, Button, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import { useAPI } from 'contexts/APIProvider'
import { usePractice } from 'contexts/PracticeProvider'
import { useSnackBarAlert } from 'contexts/SnackBarAlertProvider'
import APIError from 'errors/APIError'
import React from 'react'
import Header from 'components/Header';
import PreferredNurse from 'logic/PreferredNurse';
import AddPreferredNurse from './AddPreferredNurse';
import Loading from 'components/Loading';

const PracticePreferredNurses: React.FC = () => {
  const { practice } = usePractice()
  const { api } = useAPI()
  const { showAlert } = useSnackBarAlert()
  const [preferredNurses, setPreferredNurses] = React.useState<PreferredNurse[]>([])
  const [showDialog, setShowDialog] = React.useState<boolean>(false)

  const fetchPreferredNurses = React.useCallback(async () => {
    if (!practice) return
    setPreferredNurses(await api.listPreferredNurses({ practice_id: practice.practice_id }))
  }, [api, practice])

  const deletePreferredNurse = React.useCallback(async (preferredNurse: PreferredNurse) => {
    try {
      await api.deletePreferredNurse(preferredNurse.id)
      await fetchPreferredNurses()
      showAlert('success', `${preferredNurse.nurse_name} is added to your preferred list`)
    } catch (e) {
      if (e instanceof APIError) {
        showAlert('error', e.message)
      }
      console.error(e)
    }
  }, [api, fetchPreferredNurses, showAlert])

  React.useEffect(() => {
    fetchPreferredNurses()
  }, [fetchPreferredNurses])

  if (!practice) return <Loading />
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Header text='Preferred Nurses' />
      {preferredNurses.map((nurse) => (
        <Box key={nurse.id} sx={{ 
          display: 'flex', 
          flexDirection: 'row', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          borderBottom: 'solid thin lightgray'
        }}>
          <Box sx={{ flexGrow: 1 }}>
            { nurse.nurse_name } ({ nurse.nurse_role })
          </Box>
          <IconButton onClick={() => deletePreferredNurse(nurse)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <Button variant='contained' color='primary' onClick={() => setShowDialog(true)}>
        Add Preferred Nurse
      </Button>
      <AddPreferredNurse
        open={showDialog} 
        onClose={() => setShowDialog(false)} 
        reloadPreferredNurses={fetchPreferredNurses}
      />
    </Box>
  )
}

export default PracticePreferredNurses